// Видеоматериалы SUMA International (семинары, методические записи)

export const allVideoCollections = [
  {
    id: 'goleshev-aikido-seminar-2025-01-17-part-1',
    date: '2025-01-17',
    dateFormatted: '17.01.2025',
    titleRu: 'Семинар Голешева по Айкидо 2024 — часть 1',
    titleEn: 'Goleshev Aikido Seminar 2024 — Part 1',
    titleJa: 'ゴレシェフ合気道セミナー 2024 — パート1',
    descriptionRu:
      'Семинар Голешева по Айкидо 2024.\n\nЗапись опубликована в официальной группе SUMA International в Сысерти.',
    descriptionEn:
      'Goleshev Aikido Seminar 2024.\n\nPublished in the official SUMA International group in Sysert.',
    descriptionJa:
      'ゴレシェフ合気道セミナー 2024。\n\nスィセルトのSUMA International公式グループで公開された記録です。',
    image: '/images/videos/goleshev-aikido-seminar-2025-01-17-part-1.jpg',
    videos: [
      {
        id: 'video',
        titleRu: 'Часть 1',
        titleEn: 'Part 1',
        titleJa: 'パート1',
        url: 'https://vkvideo.ru/video-157476578_456239081',
      },
    ],
  },
  {
    id: 'goleshev-aikido-seminar-2025-01-17-part-2',
    date: '2025-01-17',
    dateFormatted: '17.01.2025',
    titleRu: 'Семинар Голешева по Айкидо 2024 — часть 2',
    titleEn: 'Goleshev Aikido Seminar 2024 — Part 2',
    titleJa: 'ゴレシェフ合気道セミナー 2024 — パート2',
    descriptionRu:
      'Семинар Голешева по Айкидо 2024.\n\nЗапись опубликована в официальной группе SUMA International в Сысерти.',
    descriptionEn:
      'Goleshev Aikido Seminar 2024.\n\nPublished in the official SUMA International group in Sysert.',
    descriptionJa:
      'ゴレシェフ合気道セミナー 2024。\n\nスィセルトのSUMA International公式グループで公開された記録です。',
    image: '/images/videos/goleshev-aikido-seminar-2025-01-17-part-2.jpg',
    videos: [
      {
        id: 'video',
        titleRu: 'Часть 2',
        titleEn: 'Part 2',
        titleJa: 'パート2',
        url: 'https://vkvideo.ru/video-157476578_456239082',
      },
    ],
  },
  {
    id: 'goleshev-aikido-seminar-2025-01-17-part-3',
    date: '2025-01-17',
    dateFormatted: '17.01.2025',
    titleRu: 'Семинар Голешева по Айкидо 2024 — часть 3',
    titleEn: 'Goleshev Aikido Seminar 2024 — Part 3',
    titleJa: 'ゴレシェフ合気道セミナー 2024 — パート3',
    descriptionRu:
      'Семинар Голешева по Айкидо 2024.\n\nЗапись опубликована в официальной группе SUMA International в Сысерти.',
    descriptionEn:
      'Goleshev Aikido Seminar 2024.\n\nPublished in the official SUMA International group in Sysert.',
    descriptionJa:
      'ゴレシェフ合気道セミナー 2024。\n\nスィセルトのSUMA International公式グループで公開された記録です。',
    image: '/images/videos/goleshev-aikido-seminar-2025-01-17-part-3.jpg',
    videos: [
      {
        id: 'video',
        titleRu: 'Часть 3',
        titleEn: 'Part 3',
        titleJa: 'パート3',
        url: 'https://vkvideo.ru/video-157476578_456239083',
      },
    ],
  },
]

const pickLocalized = (item, language, field) => {
  if (language === 'ja') return item[`${field}Ja`]
  if (language === 'ru') return item[`${field}Ru`]
  return item[`${field}En`]
}

export const getLocalizedVideoCollections = (language) => {
  return [...allVideoCollections]
    .map((item) => ({
      id: item.id,
      date: item.dateFormatted,
      title: pickLocalized(item, language, 'title'),
      description: pickLocalized(item, language, 'description'),
      image: item.image,
      partsCount: item.videos.length,
      videos: item.videos.map((video) => ({
        id: video.id,
        url: video.url,
        title: pickLocalized(video, language, 'title'),
      })),
    }))
    .sort((a, b) => {
      const collA = allVideoCollections.find((c) => c.id === a.id)
      const collB = allVideoCollections.find((c) => c.id === b.id)
      return (collB?.date || '').localeCompare(collA?.date || '')
    })
}

export const getVideoCollectionById = (collectionId, language) => {
  const item = allVideoCollections.find((c) => c.id === collectionId)
  if (!item) return null

  return {
    id: item.id,
    date: item.dateFormatted,
    title: pickLocalized(item, language, 'title'),
    description: pickLocalized(item, language, 'description'),
    image: item.image,
    videos: item.videos.map((video) => ({
      id: video.id,
      url: video.url,
      title: pickLocalized(video, language, 'title'),
    })),
  }
}
